import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import * as Yup from 'yup';

import { $t } from '../../../_metronic/i18n/formatMessage';
import { DocumentDirectionTypes } from '../../../_metronic/constants/general';

const useConfigureTemplateClientSchema = () => {
  const { formatMessage } = useIntl();

  /* ----------------------------- formik starter ----------------------------- */
  const initialValues: { [key: string]: any } = useMemo(
    () => ({
      variable_clients: [],
    }),
    [formatMessage]
  );

  const required = $t('This field is required');

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        variable_clients: Yup.array().when(['type'], {
          is: (type: any) => {
            return type === DocumentDirectionTypes.External;
          },
          then: (schema) =>
            schema.required(required).min(1, formatMessage({ id: 'Please choose at least one' })),
        }),
      }),
    [formatMessage]
  );

  return {
    initialValues,
    validationSchema,
  };
};

export { useConfigureTemplateClientSchema };
